import { AxiosError } from "axios";
import { OnahToasts } from "./onahToasts";
import { BaseResponse } from "interface/baseResponse";

export const handleRequestError = (error: AxiosError<BaseResponse> | any, defaultMessage = 'An error occurred.') => {
  if((error as AxiosError).code !== 'ERR_CANCELED' ) {
    try {
       let useMessage = null;
       let statusCode = error.response?.status?.toString();
       if (statusCode?.startsWith('4') || statusCode?.startsWith('5')) {
         const data = error?.response?.data;
         if(typeof data?.message === 'object') {
           useMessage = (data.message as Array<string>).join(', ');
         } else {
           useMessage = data?.message;
         }
       }
       OnahToasts.error(useMessage ?? defaultMessage);
     } catch(err) {
   
     }
  }
};